import type { Auth, User as FBUser, UserCredential } from 'firebase/auth';
import { createContext, useContext } from 'react';

import type { Session } from './types.ts';

export interface AuthContext {
  loading: boolean;
  currentUser: FBUser | null;
  session?: Session | null;
  signInWithEmailAndPassword: (login: string, password: string) => Promise<UserCredential>;
  sendPasswordResetEmail: (email: string, url: string) => Promise<void>;
  verifyPasswordResetCode: (code: string) => Promise<string>;
  confirmPasswordReset: (oobCode: string, newPassword: string) => Promise<void>;
  signOut: () => Promise<void>;
}

export interface AuthProviderProps {
  children: React.ReactNode;
  auth: Auth;
  testConfig?: Session;
}

export const authContext = createContext<AuthContext>({
  confirmPasswordReset: () => {
    throw new Error('Not implemented. Ensure you are inside the AuthContext');
  },
  currentUser: null,
  loading: false,
  sendPasswordResetEmail: () => {
    throw new Error('Not implemented. Ensure you are inside the AuthContext');
  },
  session: null,
  signInWithEmailAndPassword: () => {
    throw new Error('Not implemented. Ensure you are inside the AuthContext');
  },
  signOut: () => {
    throw new Error('Not implemented. Ensure you are inside the AuthContext');
  },
  verifyPasswordResetCode: () => {
    throw new Error('Not implemented. Ensure you are inside the AuthContext');
  },
});

export const useAuth = () => useContext(authContext);
